window.i18n = {
    "messages": {
        "login": "Sign in",
        "or": "or",
        "create_account": "create an account",
        "hello_user": "Hi, {0}!",
        "logged_in_as": "You are signed in as",
        "have_account": "Do you already have a PriceTravel account?",
        "login_or_create": "to book faster and manage your trips with ease.",
        "hotel": "HOTEL",
        "who_checkin": "Who will check in?",
        "self_checkin": "Me",
        "other_checkin": "Someone else",
        "other_checkin_description": "The property will ask for a valid ID at check-in.",
        "roomNew": "Room",
        "adultNew": "Adult",
        "adultsNew": "Adults",
        "optional": "(Optional)",
        "MinorNew": "Minor",
        "MinorsNew": "Minors",
        "years": "years",
        "year": "year",
        "enter_your_data_form": "We’ll use this information to send your booking confirmation.",
        "enter_your_data_form_com": "That person will need to show a valid ID when arriving at the property.",
        "enter_your_data_form_com_colom": "That person will need to show a valid ID when arriving at the property.",
        "information_contact": "Enter your contact details",
        "typical_food": "Typical food",
        "dishes_not_miss": "Dishes you can't miss",
        "country_typical_food": "Typical food of",
        "read_more": "Read more details",
        "read_less": "Read fewer details",
        "see_other_destinations": "See other destinations in",
        "hotels": "Hotels",
        "break_weekend": "Weekend break",
        "destination_title": "Take advantage of any occasion to travel",
        "escape_two_weeks": "Escape in two weeks",
        "plan_vacation": "Plan your vacation",
        "enjoy_weather": "Enjoy the weather",
        "tips_weather": "Tips to enjoy the weather",
        "weather_at": "The weather in",
        "prepare_luggage": "Prepare your luggage for",
        "what_expect_weather": "What to expect from the weather in",
        "current_conditions": "Current conditions",
        "code_weather": "°C",
        "min": "min",
        "max": "max",
        "full_forecast": "Full forecast",
        "see_more": "See more",
        "see_less": "See less",
        "know_destinations": "Discover destinations and travel options in",
        "points_pricetravel": "{0} <br/> Sales Points",
        "select_atention": "Sales points",
        "home": "Home",
        "points_pricetravel_desc": "Personalized advice for everything you need for your trip.",
        "help_you_organize": "We help you organize your trip",
        "search_pdv": "Search your sales point",
        "state": "State",
        "all": "All",
        "all_images": "See all images",
        "custom_guide": "Personalized advice",
        "custom_guide_desc": "We ensure to provide you with the best options for every detail of your trip.",
        "easy_access_schedule": "Easy access and extended hours",
        "easy_access_schedule_desc": "We are located in shopping centers and open 7 days a week.",
        "pay_easy": "Pay easily and safely",
        "pay_easy_desc": "We offer various payment methods and a layaway system.",
        "know_paymethods": "Learn about payment methods",
        "back_to_list": "Back to the list",
        "open": "Open",
        "schedule": "Schedule",
        "address": "Address",
        "references": "References",
        "select_option": "Choose a state",
        "phone": "Phone",
        "call": "Call",
        "closed": "Closed",
        "path": "/points-of-sale/",
        "wa_contact": "Contact",
        "see_more_method_payments": "Explore payment options",
        /**Checkout */
        "secure_your_reservation": "Secure your reservation!",
        "secure_your_reservation2": "Secure your reservation",
        "add_your_info_text": "Enter your information to <strong>ensure the rate and availability</strong> of your trip",
        "secure_your_reservationRAPD": "Book now and pay later!",
        "time_to_pay_RAPD": "Earn time to pay for your accommodation",
        "btn_how_works_RAPD": "Discover how it works",
        "experts_service": "Our experts at your service",
        "24_support_text": "Attention 24 hours, 365 days a year",
        "contact_us_btn": "Contact us",
        "session_login_session_description2": "Get instant discounts",
        "session_login_session_description3": "Save up to 10% on your next trip by shopping with your {0} account",
        "login_text_btn": "Sign in",
        "register_text_btn": "Create Account",
        "secure_your_reservationRAPDDetail": "Travel with all benefits: <b>complete the form</b>, secure your place and pay later.",
        "this_is_last_step": "!<strong>This is the last step,</strong> just click and save your spot!",
        "enter_your_data": "Traveler Information",
        "method_of_payment": "Payment Information",
        "confirmation": "Confirmation",
        "first_name": "First Name",
        "last_name": "Last name",
        "email": "Email ",
        "here_we_send_itinerary": "We'll send your travel itinerary here",
        "confirm_email": "Confirm email",
        "phone": "Phone number",
        "continue": "Continue booking ",
        "i_have_read": "By clicking 'Continue' you are accepting our",
        "privacy_terms_and_reservation_police": "reservation policies and the privacy policy",
        "type_your_first_name": "Type your first name",
        "type_your_last_name": "Type your last name",
        "type_your_email": "Type your email",
        "type_your_email_again": "Confirm your email",
        "summary_reservation": "Booking details",
        "checkin": "Check in",
        "checkout": "Check out",
        "lodging_days": "night(s) for accommodation",
        "taxes_and_fees": "Taxes",
        "taxes": "taxes",
        "of_taxes": "of taxes",
        "total": "Total",
        "stay_of": "Stay of",
        "nights": "nights",
        "night": "night",
        "per": "per",
        "off": "off discount",
        "room": "room",
        "rooms": "rooms",
        "rooms-title": "Rooms",
        "no-need-pay-today": "Payment is not required today! ",
        "pay-accommodation": "Pay at the property.",
        "all-inclusive": "All Inclusive",
        "guests": "Guests",
        "messagge-fee": "Rates quoted {0} are informative and based on  current exchange rates. You will pay ",
        "messagge-fee-2": "at the property.",
        "messagge-fee-3": "in USD",
        "to": "Until",
        "price": "Price",
        "pay-accommodation-title": "Pay at accommodation",
        "resort-fee": "Resort fee",
        "months_without_interest": "meses sin intereses",
        "the_best_price": "The best price, guaranteed",
        "the_best_price_description": "If you find a better price on another website for the same stay, we will match it.",
        "more_information": "More information",
        "purchases_safe": "Your purchases at {0} are safe.",
        "for": "For",
        "adults": "adults",
        "adult": "adult",
        "children": "child",
        "childrens": "childrens",
        "and": "and",
        "you_may": "You can",
        "cancel_free": "cancel for free",
        "reservation_until": "this reservation until",
        "reservation_until_h_c": "Until",
        "reservation_until_room": "until",
        "wa_contact": "Contact us",
        "free_cancellation": "FREE cancellation",
        "free_cancellation_room": "Free cancellation",
        "checkout_title": "Checkout",
        "dates_server_cancellation": "The dates and times correspond to the Mexico City time zone.",
        "description_cancellation_free": "FREE cancellation until 23:59 hrs on",
        "description_cancellation_free_to": " from 00:00 hrs on",
        "description_cancellation_penalty": "your reservation will have a penalty.",
        "close": "Close",
        "cancellation_policy": "Cancellation policies",
        "success_voucher": "Great, get ready to travel!",
        "processing_booking": "We are processing your reservation",
        "reservacion_id": "Booking locator",
        "we_send_email": "We send the reservation details to the email",
        "description_voucher": "You make sure you receive our messages",
        "description_voucher_detail": "If after a few minutes you do not see our message in your email, check the spam folder, if it is there, mark it as a secure email so that you can receive {0} emails without any problem.",
        "go_home": "Back to home",
        "thankyou_page": "Confirmation",
        "error_title": "An error has occurred",
        "error_description": "Our apologies. We were unable to obtain the requested information.",
        "error_list_one": "The servers delete the search information after some time of inactivity. This protects your privacy and helps the site work better.",
        "error_list_two_bold": "Link from bookmarks",
        "error_list_two": "The pages that you add to your browser's bookmarks are built with information that is based on your previous selections (such as rates for a specific date). These pages cannot be used to obtain updated information.",
        "RATE_NOT_FOUND": "An error has occurred with the current quote, please call <a href='tel:18554378999'>+1 855 4378 999</a> for follow-up",
        "ROOM_NOT_FOUND": "An error has occurred with the current quote, please call <a href='tel:18554378999'>+1 855 4378 999</a> for follow-up",
        "HOTEL_NOT_FOUND": "Hotel not found",
        "VOUCHER_NOT_FOUND": "Voucher not found",
        "ERROR_DEFAULT": "An error has occurred",
        "tax": "Tax",
        "rapd_title_summary": "Book now and pay later",
        "total_reservation": "Total",
        "total_booknow": "Pay now",
        "date_limit_booknow": "Pay before",
        "midday": "noon",
        "tax_include": "Includes taxes",
        "tax_no_include": "Taxes no include",
        "bags": "Your reservation is ready!",
        "reservation_number": "Your locator number is",
        "email_reservation_voucher": "We send you a confirmation email to",
        "email_reservation_voucher_description": "the confirmation of your reservation with a locator number, which will help you make your payments.",
        "download_itinerary": "Download Itinerary",
        "date_checkin_checkout": "Arrival and departure date",
        "paxes": "Guests",
        "room_type": "Room type",
        "mealplan": "Meal plan",
        "payment_method": "Payment method",
        "payment_plan": "Payment plan",
        "payment_total": "Total paid",
        "get_invoice": "Obtener factura",
        "cancellation_polcy": "Cancellation policy",
        "cancellation_polcy_legal": "Your reservation has a period in which no penalties apply if you cancel your reservation. Note that this period has a fixed duration. Check details and penalties in your itinerary.",
        "reservation_holder": "Reservation holder",
        "reservation_holder_booking": "Person who will check-in and check-out at the hotel",
        "reservation_card": "Reserve without credit card.",
        "price_and_availible": "Guaranteed price and availability.",
        "payment_later_interes": "Pay later in installments",
        "residents_colo": "Colombian Residents",
        "residents_peru": "Residents of Peru",
        "detail_residents_colo": "For reservations and stays until December 31, 2022, according to Law 2068 of 2020, a 0% accommodation VAT applies. For stays starting January 1, 2023, Colombians must pay VAT (nineteen percent) directly at the hotel.",
        "detail_residents_peru": "*** Peruvian residents may be required to pay the national VAT (value-added tax) (18%) at the property. Foreign tourists presenting a valid tourist visa or Andean Migration Card along with a valid passport may be exempt from this tax.",
        "residents_extran_detail_info": "The VAT tax also applies to foreigners who stay in the country for at least 60 consecutive days. The tax may apply to the entire room if shared with someone subject to paying the tax.",
        "residents_extran": "Foreigners",
        "residents_extran_detail_info_2": "According to Decree 2646 of the Ministry of Finance and Public Credit of Colombia, individuals residing abroad who purchase a tourist plan or package (lodging + any meals or transportation) are exempt from paying the tax, provided they present their passport with the corresponding Colombian customs immigration stamps at the hotel. This process will be valid as long as hotel check-in occurs within 30 days of entering the country.",
        "please_wait_voucher": "We are processing your reservation, please wait a moment.",
        "please_wait_voucher_loader": "This may take a few seconds. Please don’t close the page.",
        "resort_feeTitle": "Resort Fee *",
        "resort_fee": "* Resort Fee to pay at the property:",
        "resort_fee_pt1": "You will be asked to pay Resort fee of",
        "resort_fee_pt2": "per room, per night) at the property.Payment will be made in property's local currency.",
        "resort_pay_now": "Pay now",
        "resort_at_property": "Pay at property",
        "colombians_vat_messages": "*For stays from January 1, 2023, Colombians must pay 19% VAT directly at the hotel.",
        "how_make_payment": "How to make your payment",
        "rapd_instruction1": "Make your payment before the date limit",
        "rapd_instruction2": "Pay monthly without interest with participating cards",
        "rapd_instruction3": "Choose the option that suits you best",
        "pay_online": "Pay online",
        "with_credit_or_debit": "We will send you a link so you can make your secure payment online.",
        "see_details_in_email": "",
        "pay_by_phone": "Pay by phone",
        "pay_bank_transfer": "Call us to pay your reservation.",
        "pay_on_pdvs": "Pay at {0} Points of Sale",
        "go_to_our_pdvs": "Visit any of our points of sale and pay with a credit card, debit card, or cash",
        "consult_the_list_pdvs": "Check the list of {0} Points of Sale",
        "booked_with_rapd_benefit": 'You booked with the benefit <strong class="promo-text">book now and pay later</strong>',
        "phone_number_pay": "+1 855 437 8999",
        "phone_number_pay_href": "18554378999",
        "your_reservation_is_confirmed": "Your reservation is confirmed",
        "source_triv_gool": "Final cost of your reservation:",
        "special_requests": "Special requests (optional)",
        "we_send_your_requests": "We will send your requests to the hotel, however they are subject to availability and possible additional charges.",
        "special_request_placeh": "Write if you need anything special for your stay (e.g. cots, extra beds, etc.)",
        "with_credit_card": "interest-free months",
        "reservation_message": "Use this number to track your reservation with",
        "site_name": "{0}",
        "review_itinerary": "Review itinerary",
        "pay_aloj": "You will pay at the accommodation",
        "pay_hotel_collect": "You will pay at the accommodation",
        "pay_hotel_collect_1": "Rates quoted in mexican pesos are informative and based on current exchange rates. You will pay",
        "pay_hotel_collect_2": "at the property + additional charges",
        "error_reserv": "Sorry. The selected option is no longer available.",
        "discount_title": "We found a better price!",
        "discount_title_2": "You already have the best price available",
        "discount_subtitle": "Apply discount of",
        "discount_subtitle_2": "on your reservation",
        "discoubt_title_btn": "Apply",
        "discoubt_title_btn_delete": "Remove",
        "discount_applicable": "A discount of has been applied",
        "placeholder_name": "Joseph",
        "placeholder_lastname": "Carter",
        "placeholder_email": "youremail@example.com",
        "placeholder_phone": "555 555 5555",
        "discount_applicable": "A discount of has been applied",
        "Show_room_details": "See room details",
        "hide_room_details": "Hide room details",
        "Total_length_of_stay": "Total length of stay",
        "you_choose": "You choose",
        "couldnt_process_payment": "We couldn´t process your payment",
        "your_reservation": "Your reservation",
        "thank_you_choosing": "Thank you for choosing PriceTravel. We are still processing your payment. We will send an email with your reservation confirmation to: ",
        "thank_you_choosing_processing": "If you don’t see it at {0} in the next few minutes, please contact us",
        "thank_you_choosing_processing_2": " at ",
        "thank_you_choosing_processing_3": " — we’re here to help!",
        "thank_you_choosingrapd": "Your reservation is being processed, and you’ll receive an email with all the details shortly.",
        "no_locator": "Booking No.",
        "use_locator_number": "Use this number locator to follow up or resolve any questions about your reservation with {0}.",
        "need_anything_else": "need anything else for your trip?",
        "reserve_flight": "Reserve a flight",
        "buy_thousands_flights": "Buy thousands of flights at the best price.",
        "view_more": "view more",
        "special_deals": "Special Deals",
        "find_best_deals": "Find the best deals an travel now",
        "traveler_information": "Travel Information",
        "step_1_of_2": "Step 1 of 2",
        "book_now_pay_later": "Book now and pay later!",
        "enter_your_details": "Secure your reservation!",
        "hurry_up": "Hurry up!",
        "rate_availability_change": "Rate and availability can change in a very short time.",
        "payment_not_required_today": "Payment is not required today!",
        "pay_at_property": "Pay at the property.",
        "travel_with_benefits": "Travel with all benefits:",
        "complete_form_secure_place": "complete the form, secure your place and pay later.",
        "reserve_without_credit_card": "Reserve without credit card.",
        "guaranteed_price_availability": "Guaranteed price and availability.",
        "accept_reservation": "By clicking the \"Continue\" button I accept the ",
        "policies_privacy_notice": "Reservation Policies and the Privacy Notice.",
        "continue2": "Continue",
        "payment": "Method of payment",
        "whos_checking": "Who's checking in?",
        "where_do_send": "Where do we send your confirmation?",
        "get_ready_travel": "Get ready to travel ",
        "get_ready_travelrapd": "You’re booked, ",
        "get_ready_travelcollect": "Your stay is ready, ",
        "get_ready_travelprocess": "We're processing your payment, ",
        "get_ready_travelefecty": "You're one step away from securing your trip, ",
        "get_ready_traveldeposit": "Just one step left, ",
        "processing_payment": "We are processing your payment",
        "processing_payment_reservation": "We’re processing your booking, ",
        "pay_later_how": "Pay later! How to make your payment?",
        "pay_at_accommodation": "You will pay at the accommodation",
        "thank_you_processing": "Thank you for choosing PriceTravel, we are processing your reservation",
        "email_confirmation": "We’ll send a confirmation email to: ",
        "email_confirmationrapd": "We’ll send all the details to ",
        "email_confirmationcollet": "We’ll send a confirmation email to: ",
        "send_payment_link": "We will send you a link to your email so you can make your secure payment online at the time you want or call us to pay for your reservation.",
        "use_number_locator": "Use this number to track your booking.",
        "check_itinerary": "Check itinerary",
        "buy_flights_best_price": "Buy thousands of flights at the best price.",
        "find_best_deals_travel": "Find the best deals an travel now",
        "summary_payment": "Summary of payment",
        "plural_suffix": "s",
        "you_w_pay_upon_arr": "Additional charges are paid upon arrival at the accommodation and are calculated according to the current exchange rate, which may vary at the time of travel.",
        "you_w_pay_upon_arr_trivago": "Charges payable at the property are calculated based on the current exchange rate, which may vary at the time of travel.",
        "thankSite": "Thanks for booking with {0}!",
        "completepayrapd": "Your spot is guaranteed, but remember —<br> you need to make the payment before the deadline to finalize your booking.",
        "preferenrapd": "Or if you prefer, you can pay by phone at",
        "hotelcollectmsg": "Remember, payment will be made directly at the hotel.",
        "efectymsg": "Download the payment information with the details needed to make your payment",
        "procespay": "We are still processing your payment. We will send you an email with your booking confirmation to: ",
        "depositmsgmain": "Make your payment before the deadline.<div style=\"margin-top: 1rem;\"> Download your payment info with all the details you need to complete your wire transfer or deposit.</div>",
        "amounttopay": "Total to Pay:",
        "amounttopaycollect": "Pay at accommodation: ",
        "amoutpaydate": "Payment deadline:",
        "amoutpaydateprint": "Payment deadline:",
        "triptraslate": "Transfer:",
        "tripsecure": "Insurance:",
        "tripcar": "Car:",
        "triptour": "Tours:",
        "printtitle": "Make your payment and get ready to travel!",
        "printresume": "BOOKING SUMMARY",
        "printmensaje": "If we don't receive your payment on time, your reservation will be cancelled.",
        "printisntruccion": "PAYMENT INSTRUCTIONS",
        "printisntruccionmsg_pricetravel": "Make a transfer or deposit at the bank of your choice.",
        "printisntruccionmsg_tiquetesbaratos": "How to pay via bank deposit:",
        "printaccounts": "Bank accounts",
        "printcount": "Account: ",
        "printclabe": "CLABE: ",
        "printulite": "Once your payment is made",
        "printfinalice": "Send an email to pagosbancarios@pricetravel.com, indicating your reservation number and attaching a clear image of your payment receipt.",
        "pritcall": "Call {0} to verify with an agent that your payment was received.",
        "printalert": "If your payment is not reported and validated by one of our agents before the deadline, we won't be able to guarantee your reservation or the quoted service rates.",
        "amoutpaytime": "If your payment isn’t confirmed by the deadline, we can’t guarantee your reservation or the quoted rates.",
        "rapdonlyfalt": "Just one step left: complete your payment to secure the trip.",
        "collect_fees": "Prices in {0} are for reference only and based on the current exchange rate.",
        "collect_fees2": " Payment will be made in {0}.",
        "title_card_deposit": "Complete your payment to secure your trip.",
        "title_efecty": "Make your payment with Efecty",
        "btnItineraryDeposit": "Download Payment Information",
        "complementary_summary": "Reservation details",
        "complementary_summary_payment": "Summary of payment",
        "accept_cards": "We accept all major credit cards.",
        "secure_purchase": "100% secure purchase.",
        "best_price": "Best price guaranteed!",
        "information_important": "Important information for your booking",
        "impuest_local": "Tax only for local residents <span class=\"\">VAT 18%</span>",
        "impuest_local_colo": "Tax only for local residents <span class=\"\">VAT 19%</span>",
        "redesidentes_peru": "Peruvian residents:",
        "redesidentes_peru_detail": "Must pay a national VAT (18%) directly at the accommodation.",
        "redesidentes_extran": "Foreign residents:",
        "redesidentes_extran_detail": "Foreign tourists who present a valid tourist visa or Andean Migration Card and a valid passport may be exempt from national VAT payment.",
        "close_modal_peru": "Close",
        "redesidentes_colo": "Colombian residents:",
        "redesidentes_colo_detail": "According to Decree 2646 of the Ministry of Finance and Public Credit of Colombia, Colombian residents must pay VAT (19%) directly at the hotel. The tax may apply to the entire room if sharing with someone subject to this tax.",
        "redesidentes_extran_colo_detail": "Foreigners who remain in Colombia for at least 60 consecutive days must pay the VAT (19%) directly at the hotel. The tax may apply to the entire room if sharing with someone subject to this tax. Exceptions: According to Decree 2646 of the Ministry of Finance and Public Credit of Colombia, foreign residents who purchase a tourist package (accommodation + meals or transportation) and present their passport with corresponding Colombian immigration stamps proving entry are exempt from this tax. This process is valid provided that the hotel check-in occurs within no more than 30 days of entering the country."
        , "your_offer": "Your hotel was:",
        "offer_wow": "Mystery Offer {0}",
        "offer_wow_subtitle": "Complete your booking and get ready to be surprised!",
        "offer_wow_subtitle_2": "When you confirm your purchase, you’ll unlock one of our selected hotels.",
        "redesidentes_extran_colo_detail": "Foreigners who remain in Colombia for at least 60 consecutive days must pay the VAT (19%) directly at the hotel. The tax may apply to the entire room if sharing with someone subject to this tax. Exceptions: According to Decree 2646 of the Ministry of Finance and Public Credit of Colombia, foreign residents who purchase a tourist package (accommodation + meals or transportation) and present their passport with corresponding Colombian immigration stamps proving entry are exempt from this tax. This process is valid provided that the hotel check-in occurs within no more than 30 days of entering the country.",
        "invoice_name": "Full name / Company name",
        "invoice_email": "Billing email",
        "invoice_tiquetesbaratos_code": "Document number / NIT / NUT",
        "invoice_pricetravel_code": "Document number /  RFC / Tax ID / NIF",
        "invoice_type": "Identity document",
        "invoice_pricetravel_hide": "Choose a type",
        "invoice_tiquetesbaratos_hide": "Choose a type",
        "invoice_title": "Invoicing",
        "invoice_check": "I need to invoice my purchase,",
        "invoice_description": "The invoice will coming in the next 24 hours to reservation email after confirmation.",

        "invoice_pricetravel_nit": "RFC / Tax ID number",
        "invoice_pricetravel_cc": "Citizenship card",
        "invoice_pricetravel_ti": "ID card",
        "invoice_pricetravel_pp": "Passport",
        "invoice_pricetravel_ce": "Foreigner's ID card",
        "invoice_pricetravel_other": "Other",

        "invoice_tiquetesbaratos_nit": "NIT / RUT (with verification digit)",
        "invoice_tiquetesbaratos_cc": "Citizenship card",
        "invoice_tiquetesbaratos_ti": "ID card",
        "invoice_tiquetesbaratos_pp": "Passport",
        "invoice_tiquetesbaratos_ce": "Foreigner's ID card",
        "invoice_tiquetesbaratos_other": "Other",
        "nothing_search_results": "No results found",
        "invoice_save_data": "Your invoice data has been saved",

        "transfer_pricetravel": "Round-trip transfer",
        "transfer_tiquetesbaratos": "Round-trip transfer",
        "transfer_detail": "Airport - Hotel -Airport",
        "add_complementary": "Add complementary services",
        "continue_with_searchpricetravel": "Your recent searches",
        "continue_with_searchtiquetesbaratos": "Your recent searches",
        "print_payment": "Make a deposit to any of the following bank accounts.",
        "print_payment_whatsapp": "Report your payment via WhatsApp at +{0} or call our customer service line: {1}",
        "print_payment_confirm": "Once your payment is confirmed, your reservation will be issued and sent to the email you provided.",
        "print_payment_time": "Confirmation hours",
        "print_payment_time_detail": "Monday to Friday: 07:00 AM - 10:00 PM<br>Saturdays, Sundays and Holidays: 07:00 AM - 09:00 PM",
        "print_bank_account": "BANK DETAILS",
        "print_bank_account_title": "Account holder:",
        "print_bank_account_confirm": "Send your proof of payment via WhatsApp to +{0} or via email if instructed by one of our agents.",
        "print_bank_account_confirm_detail": "Make sure to include your reservation number and full name.",
        "print_bank_account_confirm_confirm": "Wait for official confirmation from our team.",
        "print_bank_account_confirm_confirm_detail": "Once your payment is validated, you will receive a confirmation email with your travel details.",
        "print_important": "Important",
        "print_tariff_guarantee": "The fare is only guaranteed once the deposit is reported to our customer service lines.",
        "print_payment_guarantee": "Vuelos Tiquetes Baratos is not responsible for issuing tickets if your payment is not reported and confirmed by one of our agents. Only cash payments are accepted, checks are not allowed.",
        "print_bank_account_guarantee": "We offer the bank deposit option to our clients as an additional way to facilitate their payment. According to Article 4 of Resolution No. 3596 of 2006, modified by Resolution 4561 of October 30, 2006 issued by the Civil Aeronautics Authority, a higher Administrative Fee must be charged due to human intervention.",
        "print_bank_account_guarantee_detail": "Official source: <a href=\"https://www.aerocivil.gov.co/consulta-de-tarifas/\" style=\"font-weight: 400;color: #000;text-decoration: underline;\" target=\"_blank\">www.aerocivil.gov.co</a>",
        //EFECTY
        "print_payment_efecty": "How to pay with Efecty?",
        "print_payment_efecty_detail": "Download the payment reference and agreement code shown below.",
        "print_payment_efecty_confirm": "Go to a Service Point with this information and make your cash payment.",
        "print_payment_efecty_confirm_detail": "You will receive a confirmation email once the payment is completed.",
        "print_payment_efecty_time": "You have until <strong>{0}</strong> to pay. If you do not, your reservation<br> will be canceled.",
        "print_payment_efecty_code": "Agreement code:",
        "print_payment_efecty_reference": "Payment reference:",
        "print_payment_efecty_no_confirm": "Didn't receive confirmation in 12 hours? Write to us at",
        "print_payment_efecty_no_confirm_time": "at",
        "insurance": "Travel insurance",
        "add_complementary": "Add complementary services for your trip"
    },
    "url": {
        "url_terms_pricetravel": "/legal/terms-and-conditions",
        "url_terms_tiquetesbaratos": "/assets-tb/files/terminos-condiciones.pdf",
        "url_best_price": "/help_us/price_garantee",
        "url_go_home": "/",
        "url_go_itinerary_pricetravel": "/help-center/itinerary",
        "url_go_itinerary_tiquetesbaratos": "/help-center/itinerary",
        "url_detail": "hotel/",
        "url_list": "hotels/",
        "url_destination": "destination",
        "url_flights": "/flights",
        "url_tours_pricetravel": "/en/deals",
        "url_tours_tiquetesbaratos": "/vuelos/promociones-tiquetes-aereos-origen"
    },
    "breakdown": {
        "TaxExcluded": "Taxes not included",
        "TaxExcluded_CO": "For local residents only",
        "TaxIncluded": "Taxes included",
        "HotelFees": "Hotel fees",
        "ResortFees_tiquetesbaratos": "Accommodation charges",
        "ResortFees_pricetravel": "Resort fee",
        "ResortFee_tiquetesbaratos": "Accommodation charge",
        "ResortFee_pricetravel": "Resort fee",
        "ResortFees_sub": "to be paid at the accommodation",
        "ResortFee_sub": "to be paid at the accommodation",
        "HotelMandatoryTax_sub": "to be paid at the accommodation",
        "HotelMandatoryFee_sub": "to be paid at the accommodation",
        "HotelMandatoryTax_tiquetesbaratos": "Tax applicable only to local residents",
        "HotelMandatoryTax_pricetravel": "Local tax",
        "HotelMandatoryFee": "Mandatory hotel fees",
        "HospitalityTax": "Hospitality insurance",
        "HospitalityTax_sub": "Per person for the entire stay",
        "charges_not_included": "Additional charges",
        "HotelMandatoryService_tiquetesbaratos": "Accommodation charges",
        "HotelMandatoryService_pricetravel": "Accommodation service charge",
        "HotelMandatoryService_sub": "to be paid at the accommodation",
        "to_pay_at_accommodation": "To pay at the accommodation",
        "title_taxes": "Taxes and fees",
        "non_refundable": "Non-refundable",
        "included": "Included",
        "partial_cancellation": "Partial cancellation",
        "view_price_breakdown": "View price breakdown",
        "local-tax": "local tax",
        "vat": "VAT",
        "tourist-tax": "tourist tax",
        "goods-and-services-tax": "goods and services tax",
        "city-tax": "city tax",
        "towels-fee": "towels fee",
        "electricity-fee": "electricity fee",
        "bed-linen-fee": "bed linen fee",
        "gas-fee": "gas fee",
        "oil-fee": "oil fee",
        "wood-fee": "wood fee",
        "water-usage-fee": "water usage fee",
        "transfer-fee": "transfer fee",
        "linen-package-fee": "linen package fee",
        "heating-fee": "heating fee",
        "air-conditioning-fee": "air conditioning fee",
        "kitchen-linen-fee": "kitchen linen fee",
        "housekeeping-fee": "housekeeping fee",
        "airport-shuttle-fee": "airport shuttle fee",
        "shuttle-boat-fee": "shuttle boat fee",
        "sea-plane-fee": "sea plane fee",
        "ski-pass": "ski pass",
        "wristband-fee": "wristband fee",
        "visa-support-fee": "visa support fee",
        "water-park-fee": "water park fee",
        "club-card-fee": "club card fee",
        "conservation-fee": "conservation fee",
        "credit-card-fee": "credit card fee",
        "pet-fee": "pet fee",
        "internet-fee": "internet fee",
        "unknown": "unknown",
        "parking-fee": "parking fee",
        "insurance": "insurance",
        "service-fee": "service fee",
        "resort-fee": "resort fee",
        "booking-fee": "booking fee",
        "tourism-fee": "tourism fee",
        "destination-fee": "destination fee",
        "extra-bed-fee": "extra bed fee",
        "environment-fee": "environment fee",
        "children-extra-fee": "children extra fee",
        "cleaning-fee": "cleaning fee",
        "book-direct-service-fee": "book direct service fee",
        "airbnb-short-term-cleaning-fee": "airbnb short term cleaning fee",
        "state-tax": "state tax",
        "county-tax": "county tax",
        "occupancy-tax": "occupancy tax",
        "transient-occupancy-tax": "transient occupancy tax",
        "home-sharing-tax": "home sharing tax",
        "harmonized-sales-tax": "harmonized sales tax",
        "minimum-alternate-tax": "minimum alternate tax",
        "early-check-in": "early check in",
        "late-checkout": "late checkout",
        "deposit": "deposit",
        "food": "food",
        "laundry": "laundry",
        "management": "management",
        "pool": "pool",
        "pool-heating": "pool heating",
        "toiletries": "toiletries",
        "tour": "tour",
        "car-rental": "car rental",
        "additional-charge": "additional charge",
        "miscellaneous": "miscellaneous",
        "shipping": "shipping",
        "activities": "activities",
        "flights": "flights",
        "gift-basket": "gift basket",
        "chef": "chef",
        "meet-and-greet": "meet and greet",
        "dock-fee": "dock fee",
        "utility-fee": "utility fee",
        "hot-tub-fee": "hot tub fee",
        "breakfast": "breakfast",
        "beverage": "beverage",
        "meal": "meal",
        "minibar": "minibar",
        "business-center": "business center",
        "equipment-rental": "equipment rental",
        "damage-charge": "damage charge",
        "homeowners-association": "homeowners association",
        "golf-cart-rental": "golf cart rental",
        "additional-cleaning-fee": "additional cleaning fee",
        "community-fee": "community fee",
        "early-checkout": "early checkout",
        "late-check-in": "late check in"
    },
    "transfer": {
        "title_pricetravel": "Round-trip transfer Airport - Hotel",
        "title_tiquetesbaratos": "Round-trip transfer Airport - Hotel",
        "from": "Departure point:",
        "note": "If you need a transfer from another airport, contact us by phone.",
        "to": "One-way: ",
        "flight": "Flight",
        "time": "Time:",
        "return": "Return: ",
        "service": "Shared service",
        "total": "Total price:",
        "add": "Add",
        "remove": "Remove",
        "flight_info": "Flight information",
        "arrival": "ARRIVAL FLIGHT:",
        "departure": "DEPARTURE FLIGHT:",
        "airline": "Airline",
        "flight_number": "Flight number",
        "arrival_time": "Arrival time",
        "departure_time": "Departure time",
        "info": "Don't have the details yet? Don’t worry. You can contact us later to provide your flight information.",
        "add_button": "Add",
        "add_transfer": "ADDED",
        "total_person": "For {0} persons"
    },
    "insurance": {
        "title_pricetravel": "Travel Insurance",
        "title_tiquetesbaratos": "Travel Insurance",
        "add": "Add",
        "remove": "Remove",
        "coverage_includes": "View coverage details",
        "total": "Total price:",
        "modal_title": "Insurance Coverage",
        "summary_title": "Coverage Summary",
        "pdf_links_title": "PDF Links",
        "notes_title": "Notes",
        "close": "Close",
        "total_person": "For {0} persons",
        "medical_assistance": "Medical assistance",
        "add_complementary": "ADDED",
        "loss_compensation": "Loss compensation",
    },

    "mealplans": {
        "A": "American breakfast",
        "AA": "Imperial Christmas and New Years Eve",
        "AB": "Romantic Getaway",
        "AC": "Romantic Getaway and Spa",
        "AZ": "All Inclusive",
        "AD": "Lunch and dinner with drinks",
        "AE": "Breakfast (adults only)",
        "AF": "Gourmet American Breakfast",
        "AG": "Breakfast for 2",
        "AH": "Continental Breakfast for 2",
        "AI": "Breakfast & lunch",
        "AJ": "Breakfast, lunch, dinner with liquids",
        "AK": "Semi All Inclusive",
        "AL": "3 meals + 2 snacks",
        "AM": "Dining Plan",
        "AN": "Quick Service",
        "AO": "Breakfast, lunch or dinner included, beverages not included",
        "AP": "Breakfast, snack & dinner included",
        "AQ": "Breakfast, lunch or dinner included",
        "AR": "Non Refundable",
        "AS": "Drinks Included",
        "AT": "Breakfast, lunch, and dinner available only for adults",
        "AU": "Continental breakfast adults only",
        "AV": "Breakfast",
        "AW": "Food, Beverages and Tours included",
        "AX": "Breakfas for 1 adult",
        "AY": "Dinner",
        "B": "Buffet breakfast",
        "C": "Lunch",
        "E": "Room Only",
        "F": "Breakfast & dinner included",
        "G": "Breakfast, lunch & dinner included",
        "H": "Breakfast, lunch or dinner included",
        "I": "All Inclusive",
        "J": "Continental breakfast buffet",
        "K": "All Inclusive",
        "L": "Breakfast",
        "M": "Breakfast & dinner with beberages",
        "N": "Breakfast without beverages",
        "O": "Open Bar",
        "P": "Breakfast & dinner, no drinks",
        "Q": "Breakfast, lunch & dinner, no drinks",
        "R": "Buffet breakfast, no beverages",
        "S": "Breakfast and lunch or dinner, beverages not included",
        "T": "Lunch without beverages",
        "U": "2 quick service meals + 1 snack",
        "V": "2 meals + 1 snack",
        "W": "3 meals, no beverages",
        "X": "Dinner without beverages",
        "Y": "Continental breakfast without beverages",
        "Z": "Continental breakfast"
    },
    "errors": {
        "_default": "The field is not valid",
        "alpha": "alpha",
        "alpha_spaces": "alpha_spaces",
        "confirmed": "confirmed",
        "email": "email",
        "required": "required",
        "integer": "integer",
        "min": "min",
        "number": "number",
        "date_invalid": "date_invalid",
        "date_expiration": "date_expiration",
        "alpha_num_strict": "alpha_num_strict"
    },
    "customErrorMessages": {
        "first_name": {
            "required": "Enter your given name(s) exactly as they appear on your official ID.",
            "min": "Your name must have a minimum of 2 characters",
            "alpha_spaces": "The field can only contain letters"
        },
        "last_name": {
            "required": "Enter your last name(s) exactly as they appear on your official ID.",
            "min": "Your lastname must have a minimum of 2 characters",
            "alpha_spaces": "The field can only contain letters"
        },
        "email": {
            "required": "Enter a valid email.",
            "email": "Please enter a valid email address in the format: example@domain.com",
            "alpha_spaces": ""
        },
        "confirm_email": {
            "required": "Confirm your email.",
            "email": "Please make sure your email has a valid format: example@domain.com",
            "alpha_spaces": "",
            "confirmed": "The field does not match",
        },
        "phone": {
            "required": "Enter your 10-digit phone number.",
            "min": "The number must be at least 10 digits.",
            "integer": "The number must not exceed 15 digits.",
            "alpha_spaces": "",
            "The field is not valid": "The phone number must be between 7 and 15 digits."
        },
        "day": {
            "required": "What is your birth day?",
            "is_not": "Please select a valid day.",
            "The field is not valid": "Please select a valid day",

        },
        "month": {
            "required": "What is your birth month?",
            "is_not": "Please select a valid month.",
            "The field is not valid": "Please select a valid month",
        },
        "year": {
            "required": "What is your birth year?",
            "is_not": "Please select a valid year.",
            "The field is not valid": "Please select a valid year",
        },
        "dayPassport": {
            "required": "What is expiration day?",
            "is_not": "Please select a valid day.",
            "The field is not valid": "Please select a valid day",

        },
        "monthPassport": {
            "required": "What is expiration month?",
            "is_not": "Please select a valid month.",
            "The field is not valid": "Please select a valid month",
        },
        "yearPassport": {
            "required": "What is expiration year?",
            "is_not": "Please select a valid year.",
            "The field is not valid": "Please select a valid year",
        },
        "genrer": {
            "required": "Select the gender that appears on your official ID."
        },
        "nationality": {
            "required": "What is your nationality?"
        },
        "locator": {
            "required": "Enter a valid reservation number",
            "The field is not valid": "Enter a valid reservation number"
        },
        "invoice_generic": {
            "required": "Enter a valid name",
            "The field is not valid": "Enter a valid name",
            "nitFormat": "Enter the NIT/RUT with the check digit (e.g., 900123456-7)",
            "email": "Enter a valid email address",
        },
        "birthdate": {
            "date_invalid": "The date entered is not valid",
            "date_expiration": "Invalid expiration date",
            "required": "Enter your date of birth exactly as it appears on your official ID."
        },
        "passport": {
            "alpha_num_strict": "The passport entered is not valid"
        },
        "identity": {
            "alpha_num_strict": "The citizenship card entered is not valid"
        },
        "arrival_airline": {
            "required": "Arrival airline is required",
            "min": "Arrival airline must have at least 2 characters.",
            "alpha_spaces": "The field can only contain letters."
        },
        "arrival_flight_number": {
            "required": "Arrival flight number is required",
            "alpha_num": "Arrival flight number must be alphanumeric",
            "regex": "Arrival flight number must be alphanumeric and may include spaces",
            "The field is not valid": "Enter a valid arrival flight number",
        },
        "departure_airline": {
            "required": "Departure airline is required",
            "min": "Departure airline must have at least 2 characters.",
            "alpha_spaces": "The field can only contain letters."
        },
        "departure_flight_number": {
            "required": "Departure flight number is required",
            "alpha_num": "Departure flight number must be alphanumeric",
            "regex": "Departure flight number must be alphanumeric and may include spaces",
            "The field is not valid": "Enter a valid departure flight number",
        },
        "billing_Name": {
            "required": "Enter your full name / business name exactly as it appears on your official documents.",
            "alpha_spaces": "This field may only contain letters."
        },
        "id_type": {
            "required": "Select the type of document shown on your official identification."
        },
        "id_number": {
            "required": "Enter your document number / NIT / RUT.",
            "The field is not valid": "Enter a valid value.",
            "nit_format": "Enter NIT/RUT with verification digit (Ex: 900123456-7)"
        }

    },
    "formaters": {
        "cancellation": "LLLL",
        "rapd": "dddd D, MMM YYYY <br> HH:mm",
        "rapdstep1": "dddd D, MMM YYYY <br> HH:mm",
        "cancel_free": "MMM D, YYYY",
        "rapdstep3": 'dddd, MMM DD, YYYY,',
        "formathrs": "Central Time (Mexico)",
        "formathrsstep1": "hrs <br><span class=\"text-subtle font-12\">Central Time (Mexico)</span>",
        "deposit": 'dddd DD, MMM YYYY, HH:mm',
    },
    "checkout": {
        "note_charge": "Rates quoted {0} are informative and based on  current exchange rates.",
        "pay_will_be": "You will pay ",
        "pay_will_be_meta": "You will pay "
    },
    "breadcrumbs": {
        "home": "Home",
        "info": "Site Information",
        "about-us": "About us",
        "legal": "Legal",
        "terms-and-conditions": "Terms and Conditions",
        "privacy-policy": "Privacy Policy",
        "profeco-contract": "Profeco Adhesion Contract",
        "mx": "Mexico",
        "global": "USA & Rest of the World",
        "user": "User",
        "profile": "Personal information",
        "companions": "Additional persons",
        "security": "Your Account Security",
        "reservations": "Bookings and trips",
        "usuario": "User",
        "perfil": "Personal information",
        "acompanantes": "Additional persons",
        "seguridad": "Your Account Security",
        "reservaciones": "Bookings and trips",
        "payment-methods": "Payment methods",
        "invoices": "Invoice Information",
        "reviews-policy": "Review Policy",
    },
    "information": {
        "lang_es": "Spanish",
        "lang_us": "English",
        "mx": "Mexico",
        "us": "United States",
        "faq": "Frequently Questions",
        "about_us_title": "We welcome you to {0}.com",
        "no_results": "No results",
        "select_location": "Select your location",
        "site_information": "Site Information",
        "payment_methods": "Payment Methods",
        "payment_methods_description": "Learn about available payment methods",
        "billing": "Billing",
        "billing_description": "Learn how to easily get your reservation invoice",
        "about_site": "About",
        "about_site_description": "Discover more about our company, mission and values",
        "reviews_policy_title": "Review Policy",
        "reviews_policy_description": "Learn about our policy on user comments and reviews"
    },
    "security": {
        "email_subtitle": "This is the email you use to log in and where you receive confirmation of your reservations",
        "verified": "Verified",
        "password": "Password",
        "change": "Change",
        "modify_password": "Modify password",
        "check_inbox": "Check your inbox",
        "password_instructions": "We'll send an email with password reset instructions to:",
        "password_instructions_sent": "We've sent an email with password reset instructions to:",
        "email_valid_time": "Once it arrives, it will be valid for 60 minutes.",
        "send": "Send",
        "resend": "Resend"
    },
    "profile": {
        "profile": "Personal Information",
        "session_name": "Name",
        "pending": "Pending",
        "edit": "Edit",
        "first_name": "First Name(s)",
        "last_name": "Last Name(s)",
        "cancel": "Cancel",
        "update_perfil": "Profile saved successfully",
        "error_ocurred": "An error occurred while processing your request",
        "phone_login": "Phone",
        "birthdate": "Date of Birth",
        "nationality": "Nationality",
        "genre": "Gender",
        "account_security": "Your Account Security",
        "account_email_message": "Email",
        "header_redirect": "Back",
        "email": "Email",
        "passport": "Passport",
        "previus": "Previous",
        "next": "Next",
        "day": "Day",
        "month": "Month",
        "year": "Year",
        "man": "Man",
        "fem": "Woman",
        "na": "Prefer not to say",
        "optional": "Optional",
        "paxes_subtitle": "Add the information of the people who travel with you.",
        "add_paxes": "Add companion",
        "new_companion": "Add Passenger",
        "edit_companion": "Edit additional passenger",
        "save": "Save",
        "delete_paxe": "Delete companion",
        "terms": "By selecting 'Save', you agree to allow {0}.com to store the provided information",
        "message_important": "Enter the information exactly as it appears on their official ID.",
        "account": "Account",
        "reservations": "Reservations",
        "warningDelete": "Are you sure you want to remove this companion?",
        "warningDeleteCard": "Are you sure you want to delete this card?",
        "accept": "Accept",
        "dateInvalid": "Please enter a valid birthdate (earlier than today)",
        "phone__messages": "We may contact you on this number if needed regarding your reservations.",
        "cal_placeholder": "DD / MM / AAAA",
        "add_method_payment": "Add your payment method safely to speed up your booking.",
        "add_card": "Add card",
        "new_card_title": "New card",
        "default_card": "Default card",
        "expiration_card": "Expired",
        "attention": "Look out!",
        "edit_card_title": "Edit card",
        "errorDeleteCard": "Ha ocurrido un error al eliminar la tarjeta, si continua el error por favor comunicarse a atención a cliente",
        "identity": "Citizenship card",
        "travel_documents": "Travel Documents",
        "passport_number": "Passport number",
        "issuing_country": "Country of issue",
        "expiration_date": "Expiration date"
    },
    "account": {
        "go_back": "Go back",
        "greeting_user": "Hi,",
        "account_welcome_message": "Welcome to your {0} account. Manage and review your trip information.",

        "complete_personal_info_title": "Complete your personal details",
        "complete_personal_info_description": "Save your info and skip typing it every time you book. Faster, easier.",
        "complete_now_cta": "Complete now",

        "account_title": "Account",
        "account_description": "Save your info and skip typing it every time you book. Faster, easier.",
        "profile_title": "Personal information",
        "security_title": "Account security",
        "additional_title": "Additional passengers",
        "payment_title": "Payment methods",
        "invoices_title": "Billing Information",
        "invoice_description": "View the invoice for your reservations.",
        "trips_title": "Trips",
        "trips_description": "View your trips and save favorites to book whenever you like.",
        "reservations_title": "Bookings & Trips",
        "favorites_title": "Favorites",
    },
    "reservations": {
        "reservation_trips": "Bookings & trips",
        "cant_find_reservation": "Can't find a reservation?",
        "ok": "Confirmed",
        "progress": "Pending payment",
        "past": "Past trips",
        "cancelled": "Canceled trips",
        "quote": "Quotes",
        "completed": "Complete",
        "locator": "Reservation Number (Locator)",
        "where_to_go": "Where would you like to go next?",
        "no_upcoming_trips": "Looks like you don’t have any upcoming trips.",
        "search_trip_options": "Search travel options",
        "cant_find_reservation": "Can't find a reservation?",
        "Cancel": "Cancel",
        "see_itinerary": "View Travel Itinerary",
        "pay_reservation": "Pay reservation",
        "total": "Total to pay",
        "upcoming": "Upcomings",
        "progressTitle": "Payment pending",
        "new_reservation": "Find your Booking",
        "instructions": "If you have another reservation that’s not showing, you can add it manually.",
        "not_found_title": "Reservation not found",
        "error_sync_title": "An error occurred",
        "not_found": "Please check your reservation number and email address, then try again..",
        "error_sync": "We're sorry, we couldn't locate your reservation with the information you entered. Please try again or contact our customer service center.",
        "email_instruction": "The email you used when booking",
        "localizator": "Enter Number",
        "email": "Email",
        "email_placeholder": "example@gmail.com",
        "search": "Search",
        "cancel": "Cancel",
        "trash": "Cancelled",
        "cant_find_url_payment": "There was a problem trying to pay for the reservation. It may be canceled or no longer available.",
        "noResults": "No results matched",
        "cant_find_reservation_error": "This reservation could not be imported as it is not valid for this process. Please try with another reservation.",
        "nothing_reservations": "Hi {0}! Looks like you don’t have any upcoming trips.",
        "nothing_reservations_sub": "Where would you like to go next?",
        "nothing_upcoming": "No upcoming trips yet",
        "nothing_upcoming_subtitle": "Ready for your next adventure, {0}?",
        "nothing_pending-payment": "No payments pending",
        "nothing_pending-payment_subtitle": "All set, {0}! <br> You don’t have any bookings to pay for right now.",
        "nothing_past": "You don’t have any past trips yet",
        "nothing_past_subtitle": "Once you return from your first trip, <br> it’ll appear here as a memory.",
        "nothing_cancelled": "You don’t have any cancelled trips",
        "nothing_cancelled_subtitle": "Your cancelled bookings will show up here",
        "quotes_side_title": "Your getaway is still waiting!",
        "quotes_side_subtitle": "Resume your booking and make it happen.",
        "continue_booking": "Continue booking",
        "warning_reservation": "Pending reservation notice",
        "saved_reservations": "Saved Quotes",
        "categories_reservations": "Reservation categories",
        "back_button": "Return to the previous page",
        "btn_continue_reservation": "Continue booking – open the saved reservation",
        "tooltip__search_reservation": "You can find it in the confirmation email for your booking.",
        "tooltip__search_context_reservation": "Your Locator helps you track and check any information about your reservation.",
        "alt_img_cards": "Panoramic Photo",
        "title_hotel": "Hotel",
        "title_flight": "Flight",
        "title_package": "Package",
        "title_transfer": "Transfer",
        "title_tour": "Tour",
        "title_rentals": "Accommodation",
    },
    "legal": {
        "legal_info": "Legal information",
        "mx": "Mexico",
        "global": "USA & Rest of the World",
        "on_this_page_mx": "En esta página",
        "on_this_page_global": "On this page",
        "terms_and_conditions": "Terms and Conditions",
        "terms_and_conditions_mx": "Términos y condiciones",
        "terms_and_conditions_global": "Terms and Conditions",
        "terms_conditions_description": "Review the terms and conditions applicable to {0}.",
        "terms_conditions_notification_mx": "If your country of residence is other than Mexico or you made a reservation on the site outside of Mexico, the <a href='{0}'>USA and Rest of the World Privacy Policy</a> applies to you.",
        "terms_conditions_notification_global": "If your country of residence is Mexico or you made a reservation on the site from Mexico, the <a href='{0}'>Mexico Privacy Policy</a> applies to you.",
        "privacy_policy": "Privacy Policy",
        "privacy_policy_mx": "Política de privacidad",
        "privacy_policy_global": "Privacy Policy",
        "privacy_policy_description": "Learn how we protect the data you provide us through our channels.",
        "profeco_contract_mx": "Profeco Adhesion Contract",
        "profeco_contract_description": "Information for buyers in Mexico.",
    },
    "months": {
        "01": "January",
        "02": "February",
        "03": "March",
        "04": "April",
        "05": "May",
        "06": "June",
        "07": "July",
        "08": "August",
        "09": "September",
        "10": "October",
        "11": "November",
        "12": "December",
    },
    "payment": {
        "payOnline-title": "Online payment",
        "email_typo_suggestion": "Did you mean",
        "payOnline-subtitle": "Enter your reservation code and pay online. (We accept all debit and credit cards).",
        "payOnline-code": "Locator",
        "payOnline-email": "Email (the one you used to book)",
        "payOnline-consult": "Consult",
        "secure-payments": "Convenient and secure payments",
        "check-methods-pay": "Check our payment methods",
        "payment-option-depend": "*Installment payment options depend on the selected service and the purchase amount",
        "payOnline-codePlaceHolder": "Ej. 129668555",
        "payOnline-emailPlaceholder": "Ej. ejemplo@correo.com",
        "method_payments": "Payment methods",
        "tc_td": "We accept all credit and debit cards",
        "until": "Until",
        "quotas": "quotas",
        "payments_options": "Installment payment options depend on the service selected and the value of the purchase",
        "have_credit_card": "Don't you have a credit card?",
        "more_payments_methods": "We have more payment methods:",
        "bancolombia_btn": "Bancolombia Button",
        "bancolombia_pay_online": "Pay online with your Bancolombia savings or current account",
        "PSE_payment": "Online payment with PSE",
        "PSE_pay_online": "Pay online with your checking or savings account",
        "cash": "Cash",
        "pay_cash": "Pay in cash at your nearest location:",
        "effecty_pay": "Pay in cash with the collection code 112232 and the payment reference at any effective point nationwide",
        "bank_deposit": "Bank Deposit",
        "deposit_pay": "Pay online with your checking or savings account",
        "consult": "Consult",
        "title_token": "Your reservation details are as follows",
        "description": "Mr/Mrs {0}, in case of doubts, you can contact us at our helpline:",
        "tel_tiquetesbaratos": "<a href='tel:6017436620'>601 743 6620 </a>",
        "tel_pricetravel": "<a href='tel:8552468484'>(855) 246 8484 </a>",
        "owner_name": "In the name of",
        "owner_email": "Email",
        "total_amount": "For a total of",
        "go_back": "Go back to the beginning",
        "create_link": "Proceed to pay",
        "error": "An error occurred while checking the reservation data",
        "cancelled": "The reservation has been canceled",
        "not_found": "We could not find your reservation",
        "success": "Your reservation details",
        "description_cancelled": "You can try creating a new reservation on our portal, for any doubts, you can contact us at our helpline",
        "description_not_found": "Check if you entered the correct details, for any doubts, you can contact us at our helpline",
        "paid_amount": "Amount paid",
        "balance_amount": "Pending amount",
        "recaptcha_error": "Please verify that you are not a robot",
        "try_again": "Try again",
        "without_results": "No results",
        "error_email": "Enter a valid email",
        "error_locator": "Enter a valid locator",
        "modal_payment_title": "Payment Methods",
        "modal_payment_card_title": "Debit cards",
        "modal_payment_TC_promotion": "Credit card promotions",
        "modal_payment_months": "months",
        "modal_payment_months_interest": "without interest",
        "modal_payment_warning": "Payment options will depend on the service selected and the value of the purchase. Minimum purchase may apply.",
        "modal_payment_digital_wallet": "Digital Wallets",
        "modal_payment_restriction_moment": "Restrictions apply at the time of purchase",
        "flights": "Flights",
        "modal_payment_until": "Up to ",
        "payment_description_interest": "months without interest",
        "hotels": "Hotels",
        "modal_payment_and": "and",
        "packages_name": "Packages",
        "bank_deposit_transfer": "Bank Deposit or Transfer",
        "bank_deposit_transfer_description": "After completing your purchase, we'll provide instructions for making the payment at your preferred bank.",
        "pay_at_pdv": "Payment at {0} point of sale",
        "pay_at_pdv_description": "If you prefer, you can pay directly at any of our ",
        "pdv_locations": "physical point-of-sale locations",
        "modaltb_payment_title": "Payment Methods",
        "modaltb_payment_card_title": "Credit and Debit Cards",
        "modaltb_payment_until": "Up to",
        "modaltb_payment_warning": "Installment payment options depend on the selected service and the purchase amount.",
        "modaltb_payment_no_card_title": "Don’t have a credit card?",
        "modaltb_payment_other_methods": "We offer more payment methods:",
        "modaltb_payment_bancolombia": "Pay online with your Bancolombia savings or checking account",
        "modaltb_payment_pse_title": "Online payment with PSE",
        "modaltb_payment_pse_description": "Pay online with your savings or checking account",
        "modaltb_payment_cash_title": "Pay in cash",
        "modaltb_payment_cash_description": "Pay in cash at your nearest location",
        "modaltb_payment_efecty": "Pay in cash using collection code 112232 and the payment reference at any Efecty point nationwide",
        "modaltb_payment_bank_deposit": "Bank deposit",
        "pay_best_optionstb": "Comfortable and secure payments",
        "pay_best_options": "Book with the best payment option",
        "get_our_payment_methods": "Check our payment methods",
        "get_our_payment_methodstb": "Check out our payment methods"
    },
    "invoice": {
        "title": "Billing Information",
        "subtitle": "Add your billing information easily to streamline your reservations.",
        "add_button": "Add billing details",
        "add_invoice": "Add billing details",
        "edit_invoice": "Edit",
        "invoice_info": "Billing Information",
        "billing_info": "Enter your billing details exactly as they appear on your official documents.",
        "billing_Name": "Full name / Business name",
        "placeholder_billing_Name": "Full name / Business name",
        "id_type": "Identity document",
        "placeholder_id_type": "Select a document",
        "id_number_tiquetesbaratos": "Document number / NIT / RUT",
        "id_number_pricetravel": "Document number / RFC / Tax ID",
        "placeholder_id_number_1": "Ex. 900123456-7",
        "placeholder_id_number_2": "Ex. ABC123456789",
        "save": "Save",
        "update": "Update",
        "cancel": "Cancel",
        "delete_invoice": "Delete billing details",
        "noResults": "No results found",
        "email": "Billing email address",
        "placeholder_email": "Billing email address"
    },
    "cta": {
        "register_hotel": "Turn your property into a booking-generating powerhouse!",
        "register_hotel_description": "List it on <strong>{0}</strong> and connect with travelers from around the world.",
        "register_hotel_cta": "Discover how"
    },
    "booker": {
        "cancel": "Cancel",
        "apply": "Apply",
        "increment": "Increment",
        "decrement": "Decrement",
        "error_children": "Choose the age of the children",
        "childred_age": "Age",
        "adults": "Adults",
        "adults_subtle": "From 18 years",
        "flight_adults_subtle": "From 12 years",
        "childrens": "Children",
        "childrens_subtle": "(Up to {0} years)",
        "rooms": "Rooms",
        "rooms_subtle": "Total rooms",
        "years": "years",
        "year": "year",
        "age_minor": "Minor age",
        "minors_23": "0 to 23 months",
        "remove": "Remove",
        "add_room": "Add room",
        "room": "Room",
        "where_are_you_going": "Destination, hotel, point of interest",
        "where_are_you_going_sub": "Where do you want to travel?",
        "destination_placeholder": "Destination, hotel, point of interest",
        "dates": "Dates",
        "guests": "Travelers",
        "guests_sub": "Choose your guests",
        "passengers": "Passengers",
        "passengers_sub": "Choose your passengers",
        "accommodations": "Accommodation search",
        "flights": "Flight search",
        "origin": "Origin",
        "origin_sub": "Choose your airport of origin",
        "destination": "Destination",
        "destination_sub": "Choose your destination",
        "departure": "Outbound",
        "return": "Return",
        "date": "Date",
        "button": "Search",
        "type": "Flight type:",
        "round_trip_pricetravel": "Roundtrip",
        "round_trip_tiquetesbaratos": "Roundtrip",
        "one_way_pricetravel": "One-way",
        "one_way_tiquetesbaratos": "One-way",
        "select_origin": "Select an origin",
        "select_destination": "Select your destination",
        "select_dates": "Select dates",
        "select_guests": "Select guests",
        "select_different_destination": "Select a different destination",
        "max_paxes": "In trips of more than 5 people, we recommend adding another room to have more accommodation options.",
        "max_paxes_global": "Maximum {0} passengers per reservation. To add more passengers, make another reservation or contact customer service.",
        "no_destinations_found": "No destinations found",
        "search_destination": "Search destination",
        "where_do_you_want_to_go": "Where do you want to go?",
        "popular_destinations": "Most popular destinations",
        "popular_destinations_origin": "Most popular origins",
        "all_airports": "All airports",
        "notificationKids": "There must be at least 1 passenger (Adult) for each baby in arms.",
        "recent_searches": "Recent searches",
        "calendar_date": "Date",
        "calendar_arrival": "Arrival",
        "calendar_departure": "Departure",
        "calendar_nights": "nights",
        "calendar_night": "night",
        "calendar_days": "days",
        "calendar_day": "day",
        "calendar_omit": "Cancel",
        "calendar_total": "Total",
        "low_prices": "Low prices",
        "lower_prices": "Very low prices",
        "price_disclaimer": "Approximate prices in {0} per {1} for 2 adults",
        "calendar_nav": "Calendar navigation",
        "next_month": "Next month",
        "prev_month": "Previous month",
        "unavailable": "Unavailable",
        "start_date": "Start date",
        "end_date": "End date",
        "payment_summary": "Payment Summary",
        "additional_charges": "Additional Charges",
        "length_of_stay": "Length of stay",
        "you_selected": "You selected",
        "persons": "people",
        "cancellation_policies": "Cancellation Policies",
        "cancellation_policies_desc": "You can modify or cancel your booking at no cost within the allowed time; after that date, charges may apply according to the accommodation's conditions.",
        "see_more_info": "See more info",
        "refund_full": "Full refund",
        "refund_partial": "Partial refund",
        "refund_none": "No refund",
        "refund_full_desc": "You will receive a 100% refund of what you paid.",
        "refund_partial_desc": "You will receive {penalty}% of all nights. The service fee will not be refunded.",
        "refund_none_desc": "This reservation is non-refundable.",
        "cancel_before": "Before",
        "cancel_after": "After",
        "cancel_time_note": "The time indicated is based on the location of the accommodation.",
        "cancel_requirements_title": "Requirements to receive a refund",
        "cancel_requirements_desc": "If you have scheduled payments, the refund or amount you are entitled to will depend on how much you have paid at the time of cancellation.",
        "until": "Until",
        "from_date": "From",
        "rate_change_title": "Rate Update",
        "rate_change_description": "The price for this accommodation has changed since your search.",
        "rate_change_original": "Original price",
        "rate_change_new": "New price",
        "rate_change_increased": "The price has increased by",
        "rate_change_decreased": "Good news! The price has dropped by",
        "rate_change_accept": "Understood, continue",
        "sold_out_title": "No availability",
        "sold_out_description": "Sorry, this accommodation is no longer available for the selected dates. We invite you to explore other options.",
        "sold_out_button": "View other accommodations",
        "nearby_location": "Near your current location",
        "nearby_location_name": "Near {0}",
    },
    "accommodation": {
        "accommodation": "Accommodation",
        "accommodation_gallery": "Accommodation gallery",
        "go_back": "Go back",
        "go_back_to": "Go back to",
        "adult": "Adult",
        "view_all_photos": "View all photos",
        "location": "Location",
        "open_gallery": "Open gallery",
        "information": "Information",
        "services": "Services",
        "calendar": "Calendar",
        "host": "Host",
        "share": "Share",
        "save_to_favorites": "Save to favorites",
        "share_this_accommodation": "Share this accommodation",
        "share_via_facebook": "Share via Facebook",
        "share_via_whatsapp": "Share via WhatsApp",
        "copy_link": "Copy link",
        "link_copied": "Link copied",
        "menu": "Accommodation menu",
        "select_dates": "Select dates",
        "price_per_night": "Price per night",
        "book_now": "Book now",
        "modify_search": "Modify search",
        "free_cancellation": "Free cancellation",
        "where_you_will_be": "Where you will be",
        "cancellation_policy": "Cancellation policy",
        "can_cancel_free_until": "You can cancel free of charge until",
        "destination_time": "destination time",
        "if_cancel_after": "If you cancel after",
        "no_show_penalty_total": "or in case of no-show, a penalty equivalent to the total cost of the reservation will apply.",
        "if_cancel_between": "If you cancel between",
        "and": " and ",
        "penalty_is": "the penalty will be",
        "partial_cancellation": "Partial cancellation",
        "can_cancel_with_charge_until": "You can cancel with a charge of",
        "until": "until",
        "total_final": "Total final",
        "total": "Total",
        "payment_summary": "Payment summary",
        "additional_charges": "Additional charges",
        "cancellation_policies": "Cancellation policies",
        "cancellation_policies_desc": "You can modify or cancel your reservation at no cost within the allowed period; After that date, charges may apply according to the accommodation's conditions.",
        "see_more_info": "See more information",
        "adults": "Adults",
        "refund_full": "Full refund",
        "refund_partial": "Partial refund",
        "refund_none": "No refund",
        "refund_full_desc": "You will receive a 100% refund of what you paid.",
        "refund_partial_desc": "You will receive {penalty}% of all nights. The service fee will not be refunded.",
        "refund_none_desc": "This reservation is non-refundable.",
        "cancel_before": "Before",
        "cancel_after": "After",
        "cancel_time_note": "The time indicated is based on the location of the accommodation.",
        "cancel_requirements_title": "Requirements to receive a refund",
        "cancel_requirements_desc": "If you have scheduled payments, the refund or amount you are entitled to will depend on how much you have paid at the time of cancellation.",
        "rate_change_title": "Rate Update",
        "rate_change_description": "The price for this accommodation has changed since your search.",
        "rate_nofound_description": "Sorry, stay availability is over, try other dates.",
        "rate_change_original": "Original price",
        "rate_change_new": "New price",
        "rate_change_increased": "The price has increased by",
        "rate_change_decreased": "Good news! The price has dropped by",
        "rate_change_accept": "Understood, continue",
        "all": "All",
        "all_images": "All images"
    },
    "favorites": {
        "favorites": "Favorites",
        "loading_favorites": "Loading favorites",
        "follow_these_steps": "Follow these 2 simple steps to get started",
        "favorite_step_1": "Search for accommodation of your preference",
        "favorite_step_2": "During your search, tap the heart icon to save your favorite hotels",
        "here_are_your_favs": "Here you will find your saved accommodations!",
        "search": "Search",
        "hotels": "Hotels",
        "some_hotels_cheaper": "Some of your favorite hotels have dropped in price",
        "favorite_hotels": "",
        "the_hotel": "The hotel",
        "deleted_from": "has been removed from your",
        "fav_list": "favorites list",
        "undo": "Undo",
        "add_to_favs": "Add to favorites",
        "people_lower": "people",
        "people_lower_1": "people",
        "room_favs": "room",
        "list_rooms": "rooms",
        "hotel_price_decreased": "The price has dropped",
        "hotel_price_increased": "The price has increased",
        "list_room_per_night": "Room per night",
        "list_room_per_night_low": "Previous price",
        "fav_card_dates_expired": "View available dates",
        "go_back": "Go Back"
    },
};
